const PROTOCOL_PATTERN = /^[a-z][a-z\d+.-]*:/i;
const HOST_PATTERN = /^([a-z][a-z\d+.-]*:\/\/[^/]+)(\/.*)?$/i;
const DEFAULT_AVATAR_MARKER = "default";

const getContext = (baseURL = "") => {
    const normalized = String(baseURL).replace(/\/+$/, "");
    const match = normalized.match(HOST_PATTERN);
    const origin = match ? match[1] : "";
    const pathname = match ? (match[2] || "") : normalized;
    const separator = pathname.lastIndexOf("/");
    const contextPath = separator >= 0 ? pathname.slice(0, separator) : "";

    return { origin, contextPath };
};

const resolveAssetUrl = (value, baseURL = "", defaultUrl = "") => {
    if (typeof value !== "string") {
        return value || "";
    }

    const assetPath = value.trim();
    if (!assetPath || PROTOCOL_PATTERN.test(assetPath) || assetPath.startsWith("//")) {
        return assetPath;
    }
    if (assetPath === DEFAULT_AVATAR_MARKER) {
        return defaultUrl;
    }

    const { origin, contextPath } = getContext(baseURL);
    const prefix = `${origin}${contextPath}`;
    if (contextPath && (assetPath === contextPath || assetPath.startsWith(`${contextPath}/`))) {
        return `${origin}${assetPath}`;
    }

    if (assetPath.startsWith("/")) {
        return `${prefix}${assetPath}` || assetPath;
    }
    return `${prefix}/${assetPath}` || assetPath;
};

module.exports = { resolveAssetUrl };
